"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Peace() {
  const {
    ref: revealRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const sectionRef = useRef<HTMLElement | null>(null);
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const node = sectionRef.current;
      if (!node) return;
      const rect = node.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const progress = 1 - (rect.top + rect.height) / (viewportHeight + rect.height);
      const clamped = Math.max(0, Math.min(1, progress));
      setOffsetY(clamped * 80);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);
  return <section data-section-id="780" id="peace-of-mind-bar" ref={sectionRef} className="relative w-full overflow-hidden bg-[#061F3F]" style={{
    minHeight: "90vh"
  }}>
      {}
      <div className="absolute inset-0 -top-20 -bottom-20 will-change-transform" style={{
      transform: `translate3d(0, ${offsetY}px, 0)`
    }}>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1727743/img/family_legacy_protection.png" alt="Family enjoying time together in a peaceful setting" loading="lazy" decoding="async" className="h-full w-full object-cover" />
      </div>

      {}
      <div className="absolute inset-0" style={{
      background: "linear-gradient(to bottom, hsla(215, 82%, 8%, 0.78) 0%, hsla(215, 82%, 8%, 0.55) 100%)"
    }} />

      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.12] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix type='matrix' values='0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 0.5 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
      backgroundSize: "200px 200px"
    }} />

      {}
      <div className="relative z-10 flex w-full" style={{
      minHeight: "90vh"
    }}>
        <div className="mx-auto flex w-full max-w-7xl flex-col justify-end px-6 pb-20 pt-32 sm:px-10 md:pb-24 lg:px-16 lg:pb-28">
          <div ref={revealRef} className={`flex flex-col items-center text-center lg:items-start lg:text-left transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <span className="font-default text-xs uppercase tracking-[0.4em] text-[#FFCA2C]" style={{
            letterSpacing: "0.4em"
          }}>
              Legacy
            </span>

            {}
            <h2 className="mt-8 font-default font-bold leading-[1.02] text-white" style={{
            fontSize: "clamp(2.75rem, 8vw, 7rem)"
          }}>
              <span className="block">Protect Your Family</span>
              <span className="block">Final Expense Insurance</span>
              <span className="block text-[#FFCA2C]">
                Funeral Costs
              </span>
            </h2>

            {}
            <p className="mt-10 max-w-xl font-default text-base sm:text-lg leading-relaxed text-white/70">
              We provide affordable burial insurance for seniors with fast approval options. Secure your family's future today with coverage that never expires.
            </p>

            {}
            <div className="mt-12 flex flex-col items-center gap-6 sm:flex-row sm:items-center sm:gap-10 lg:items-center">
              <Button asChild size="lg" className="group h-auto rounded-md bg-[#FFCA2C] px-12 py-6 text-sm uppercase tracking-[0.2em] text-[#061F3F] shadow-lg hover:bg-[#FFCA2C]/90">
                <Link to="/HomePage">
                  <span>Get My Quote</span>
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Link to="tel:800-555-0199" className="font-default text-sm tracking-wide text-white underline decoration-white/40 underline-offset-[6px] transition-colors hover:decoration-white">
                800-555-0199
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="pointer-events-none absolute bottom-8 right-6 hidden md:flex md:right-10 lg:right-16">
          <div className="font-default text-[11px] uppercase text-white/60" style={{
          writingMode: "vertical-rl",
          transform: "rotate(180deg)",
          letterSpacing: "0.35em"
        }}>
            Licensed Insurance Professionals / Mon–Fri / 9–6 EST
          </div>
        </div>
      </div>
    </section>;
}